'use client';

import { Controller, useFormContext } from 'react-hook-form';

import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import InputAdornment from '@mui/material/InputAdornment';

// ----------------------------------------------------------------------

export function RHFAddressPlugins({
  name,
  data,
  label,
  onChange,
  multiple,
  helperText,
  hiddenLabel,
  placeholder,
  ...other
}) {
  const { control, setValue } = useFormContext();

  const options = data.map((option) => option.name);

  const renderValue = (selected, getTagProps) =>
    selected.map((option, index) => (
      <Chip {...getTagProps({ index })} key={option} label={option} size="small" variant="soft" />
    ));

  const isOptionEqualToValue = (option, value) =>
    other.disabled || option === value || (value === '' && option === options[0]);

  const handleOnChange = (event, newValue) => {
    setValue('city', '');
    setValue('zipCode', '');
    setValue(name, newValue, { shouldValidate: true });
    onChange?.(newValue);
  };

  const renderOption = (props, option) =>
    option && (
      <li {...props} key={option}>
        {option}
      </li>
    );

  const renderInput = (params, error) => {
    const baseField = {
      ...params,
      label,
      placeholder,
      helperText,
      hiddenLabel,
      error: !!error,
      inputProps: { ...params.inputProps, autoComplete: 'new-password' },
    };

    if (multiple) return <TextField {...baseField} />;

    return (
      <TextField
        {...baseField}
        slotProps={{
          input: {
            ...params.InputProps,
            startAdornment: params.inputProps.value && <InputAdornment position="start" />,
          },
        }}
      />
    );
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Autocomplete
          {...field}
          options={options}
          includeInputInList
          multiple={multiple}
          autoHighlight={!multiple}
          onChange={handleOnChange}
          renderOption={renderOption}
          id={`${name}-rhf-autocomplete`}
          disableCloseOnSelect={multiple}
          getOptionLabel={(option) => option}
          isOptionEqualToValue={isOptionEqualToValue}
          renderValue={multiple ? renderValue : undefined}
          renderInput={(params) => renderInput(params, error)}
          {...other}
        />
      )}
    />
  );
}
